import DashboardPage from "./Dashboard";

export default DashboardPage;
